<template>
  <div class="status" :class="`status--${s}`">
    <span class="status_indicator"></span>
    <p>{{ statuses[s] }}</p>
  </div>
</template>

<script>
export default {
  props: ["s", "awaiting"],
  data() {
    return {
      statuses: {
        "": "СВОБОДЕН",
        moving: "ПРЕМЕСТВАНЕ",
        onsite: "НА ОБЕКТ",
        onuser: "ПРИ СЛУЖИТЕЛ",
        repair: "ЗА РЕМОНТ",
        scrap: "ЗА БРАК",
        scrapped: "БРАКУВАН",
        missing: "ЛИПСВА?",
        waiting: "ЧАКА СЕ ОДОБРЕНИЕ",
        confirmed: "ОДОБРЕНА",
        declined: "НЕОДОБРЕНА",
      },
    };
  },
};
</script>

<style scoped lang="scss">
$black: #090909;
$gray: #5d5d5d;
$white: #fff;
$light-gray: #b1b1b1;
$dark-gray: #9c9c9c;
$brown: #a16219;
$light-brown: #f8f4e6;
$green: #58a182;
$light-green: #e6f8f1;
$blue: #889abb;
$dark-blue: #8593ac;
$red: #9f4b4b;
$dark-red: #782525;

.status {
  align-items: center;
  border: 0.5px solid $gray;
  border-radius: 85px;
  display: flex;
  height: 22px;
  padding: 0 5px;
  justify-content: center;
  position: relative;
  width: 146px;

  .status_indicator {
    background: $black;
    border-radius: 50%;
    height: 8px;
    width: 8px;
  }

  > p {
    flex: 1;
    text-align: center;
  }

  &.status--moving {
    background: $light-brown;
    border-color: $brown;
    color: $brown;

    .status_indicator {
      background: $brown;
    }
  }

  &.status--onsite,
  &.status--onuser,
  &.status--confirmed {
    background: $light-green;
    border-color: $green;
    color: $green;

    .status_indicator {
      background: $green;
    }
  }

  &.status--scrap,
  &.status--scrapped {
    background: $light-gray;
    border-color: $dark-gray;
    color: $white;

    .status_indicator {
      background: $white;
    }
  }

  &.status--repair {
    background: $blue;
    border-color: $dark-blue;
    color: $white;

    .status_indicator {
      background: $white;
    }
  }

  &.status--missing,
  &.status--declined {
    background: $red;
    border-color: $dark-red;
    color: $white;

    .status_indicator {
      background: $white;
    }
  }

  &.status--waiting {
    background: $light-brown;
    border-color: $brown;
    color: $brown;

    .status_indicator {
      background: $brown;
    }
  }
}
</style>
